import * as types from './Types.js';

export function findRepassesEnviados(filtro = '') {
  const url = filtro
    ? `/api/repasses?tipo=E&${filtro}`
    : '/api/repasses?tipo=E';
  return ({ fetch }) => ({
    type: types.REPASSES_ENVIADOS,
    payload: {
      promise: fetch(url)
    }
  });
}

export function findRepassesRecebidos(filtro = '') {
  const url = filtro
    ? `/api/repasses?tipo=R&${filtro}`
    : '/api/repasses?tipo=R';
  return ({ fetch }) => ({
    type: types.REPASSES_RECEBIDOS,
    payload: {
      promise: fetch(url)
    }
  });
}

export function findRepassesEnviadosMes(filtro) {
  return ({ fetch }) => ({
    type: types.REPASSES_MES,
    payload: {
      promise: fetch(`/api/repasses/mes?${filtro}&tipo=E`)
    }
  });
}

export function findRepassesRecebidosMes(filtro) {
  return ({ fetch }) => ({
    type: types.REPASSES_MES,
    payload: {
      promise: fetch(`/api/repasses/mes?${filtro}&tipo=R`)
    }
  });
}
